import {JsonAdapter} from "../helpers/JsonAdapter";

export class Location {
  id: string = "";
  name: string = "";
  slug: string = "";
  region?: {name: string};
  parent?: {name: string, parent?: {name: string}};
  country_code: string = "";

  static create(object:any): Location {
    const item = JsonAdapter.fill(new Location(), object);

    if(object.region) {
      item.region = object.region;
    }

    if(object.parent) {
      item.parent = object.parent;
    }

    return item;
  }

  static createMultiple(objects: Location[]): Location[] {
    const items = [];
    for (let i = 0; i < objects.length; i++) {
      items.push(Location.create(objects[i]));
    }
    return items;
  }

  static groupBy = (item: Location) => {

    return item.parent?.name;
    /*
    if(item.name == "International")
      return null;

    if(item.region)
      return item.region.name;

    if(item.parent && item.parent.parent && item.parent.parent.name == "UK")
      return item.parent.name + " ( " + item.parent.parent.name+" ) ";

    if(item.parent && item.parent.parent && item.parent.parent.name == "England")
      return item.parent.parent.name + " ( UK )";

    return "United Kingdom";*/
  };
}
